import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import Joi from 'joi-full';
import { withRouter } from 'react-router';
import compose from 'recompose/compose';
import Form from '../components/Form';
import { syncValidateData } from '../../../../common/validator';
import discountTypes from '../discountTypes';
import discountAssignment from '../discountAssignment';
import { canUserModifyDiscounts } from '../../../../common/helpers/users';

const DISCOUNT_FORM = 'discountForm';

const schema = Joi.object().keys({
  id: Joi.string().guid().optional(),
  name: Joi.string().min(2).required(),
  value: Joi.when('type', {
    is: discountTypes.percentage,
    then: Joi.number().min(0).max(100).required(),
    otherwise: Joi.number().min(0).required(),
  }),
  type: Joi.string().valid(Object.values(discountTypes)).required(),
  assignment: Joi.string().valid(Object.values(discountAssignment)).optional(),
});

const validate = (values) => syncValidateData(values, schema);

const form = reduxForm({
  form: DISCOUNT_FORM,
  onSubmitSuccess: (_values, _dispatch, props) => {
    props.router.push(props.baseUrl);
  },
  validate,
});

const formSelector = formValueSelector(DISCOUNT_FORM);

export default compose(
  withRouter,
  form,
  connect((state) => ({
    canModify: canUserModifyDiscounts(state.auth.permissions),
    discountType: formSelector(state, 'type'),
  })),
)(Form);
